import * as React from "react";
import { cn } from "@/lib/utils";
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  peer?: boolean;
  append?: string;
  children?: React.ReactNode;
  containerClassName?: string;
  noContainer?: boolean;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  peer = false,
  append,
  children,
  noContainer = false,
  ...props
}, ref) => {
  const inputElement = <input type={type} className={cn("block w-full appearance-none rounded-3xl border border-input bg-background px-4 py-3 text-sm text-foreground transition file:mr-4 file:cursor-pointer file:rounded-lg file:border-0 file:bg-secondary file:px-4 file:py-2 file:text-sm file:font-medium file:text-accent-foreground hover:file:bg-accent hover:file:text-foreground focus:border-primary focus:placeholder-opacity-100 focus:outline-none focus:ring-primary", peer ? "peer placeholder-opacity-0" : "placeholder-opacity-80", className)} ref={ref} {...props} />;
  if (noContainer) {
    return inputElement;
  }
  return <div className={cn("flex items-center", props.containerClassName)}>
        {inputElement}
        {children}
        {append && <span className="ml-2 text-sm">{append}</span>}
      </div>;
});
Input.displayName = "Input";
export { Input };